export default [
    { lat: 48.184596, lng: 16.315888 },
    { lat: 48.138169, lng: 16.428986 },
    { lat: 48.130382, lng: 16.391428 },
    { lat: 48.140117, lng: 16.325265 },
    { lat: 48.128991, lng: 16.307552 },
    { lat: 48.135249, lng: 16.272647 },
    { lat: 48.139074, lng: 16.242431 },
    { lat: 48.139074, lng: 16.242431 },
    { lat: 48.155063, lng: 16.221593 },
    { lat: 48.170700, lng: 16.188251 },
    { lat: 48.208557, lng: 16.211173 },
    { lat: 48.232855, lng: 16.199712 },
    { lat: 48.261996, lng: 16.208047 },
    { lat: 48.238754, lng: 16.239826 },
]
